module.exports = __webpack_public_path__ + "static/img/news10_12.b327477.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news10_12.png
// module id = 9r0g
// module chunks = 0